export default "__VITE_ASSET__BFVaG4R$__"